import React, { Component } from 'react';
import AccordionItem from './accordion-item';

class Accordion extends Component {

    render() {
        const { accordionItems } = this.props;

        return(
            <div className="accordion-items">
                { accordionItems.map( (item,key) => {
                    return <AccordionItem key={"title-"+key} featureKey={ key } item={ item } />
                })}
            </div>
        );
    }

}

export default Accordion;



// WEBPACK FOOTER //
// ./src/components/accordion.js